import { render, staticRenderFns } from "./choose_link.vue?vue&type=template&id=4bc7f5cf&scoped=true&"
import script from "./choose_link.vue?vue&type=script&lang=js&"
export * from "./choose_link.vue?vue&type=script&lang=js&"
import style0 from "./choose_link.vue?vue&type=style&index=0&id=4bc7f5cf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc7f5cf",
  null
  
)

export default component.exports